import React,{ Component } from 'react';

import {
  Col,
  Row,
  Button,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  FormGroup
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import MoneyInput from '../../../shared/components/MoneyInput';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';

import { roundUpToNearestTensOfCent, urlRoot } from '../../../shared/utils';

class CampaignBudgetForm extends Component {
  constructor(props){
    super(props);

    this.state = {
      validationMessages:{},
      isShowingPopover:false,
      isUsingCostPerCompletionPricing:props.activeCampaignUseCostPerCompletion || false,
      costPerCompletion:props.activeCampaignUseCostPerCompletion ? props.activeCampaignRevenueSplit : 0.2,
      revenueSplit:props.activeCampaignUseCostPerCompletion ? props.activeCampaignRevenueSplit : 0.5
    };
  }

  handleSubmit(data){
    const { isUsingCostPerCompletionPricing } = this.state;

    const { showSuperadminFeatures, availableBudget, isOnboarding } = this.props;

    const validationMessages = {};

    if(!data.lifetimeBudget){
      validationMessages['lifetimeBudget'] = 'Threshold is required';
    }

    if(data.lifetimeBudget && data.lifetimeBudget < 50){
      validationMessages['lifetimeBudget'] = 'Threshold must be at least 50 dollars';
    }

    if(isUsingCostPerCompletionPricing && showSuperadminFeatures){
      //costPerCompletion,useCostPerCompletion,revenueSplit
      data.useCostPerCompletion = true;
      data.revenueSplit = parseFloat(data.revenueSplit) / 100;
      data.costPerCompletion = parseFloat(data.costPerCompletion);

    } else if(showSuperadminFeatures){
      data.useCostPerCompletion = false;

    } else {
      delete data.useCostPerCompletion;
    }

    data.lifetimeBudget = parseFloat(data.lifetimeBudget);

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  render(){

    const {
      isShowingPopover,
      validationMessages,
      isUsingCostPerCompletionPricing,
      costPerCompletion,
      revenueSplit
    } = this.state;

    const {
      activeCampaignBudget,
      activeCampaignAgencyId,
      isShowingTutorial,
      showSuperadminFeatures,
      isOnboarding,
      availableBudget,
      currentURLForRedirect
    } = this.props;

    const addMoreFundsURL = showSuperadminFeatures ? `/superadmin/accounts/${activeCampaignAgencyId}/billing/new?redirect=${currentURLForRedirect}` : `${urlRoot(currentURLForRedirect)}/billing/new?redirect=${currentURLForRedirect}`

    return (
      <Form onSubmit={(data) => this.handleSubmit(data)}>
        <TutorialPopover
          open={isShowingPopover && isShowingTutorial}
          target='BudgetInput'
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Threshold'
        >
          <p>
            Experience will automatically end when consumers exhaust this max budget amount.
          </p>
        </TutorialPopover>
        <MoneyInput
          id='BudgetInput'
          name='lifetimeBudget'
          defaultValue={activeCampaignBudget}
          placeholder='50'
          warning={validationMessages['lifetimeBudget']}
        />
        {showSuperadminFeatures && isUsingCostPerCompletionPricing && (
          <div>
            <Row>
              <Col md='6' lg={{size:4,offset:4}}>
                <FormGroup>
                  <Label>Consumer</Label>
                  <InputGroup>
                    <InputGroupAddon style={{backgroundColor:'transparent'}}>
                      %
                    </InputGroupAddon>
                    <Input
                      name='revenueSplit'
                      type='number'
                      value={(revenueSplit * 100).toFixed(0)}
                      onChange={(e) => this.setState({revenueSplit:Math.min(Math.max(parseInt(e.target.value,10), 0), 100) / 100})}
                      step='1'
                      min='0'
                      max='100'
                    />
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md='6' lg={{size:4}}>
                <FormGroup>
                  <Label>Downtime Dollars</Label>
                  <InputGroup>
                    <InputGroupAddon style={{backgroundColor:'transparent'}}>
                      %
                    </InputGroupAddon>
                    <Input
                      type='number'
                      value={((1 - revenueSplit) * 100).toFixed(0)}
                      onChange={(e) => this.setState({revenueSplit:Math.min(Math.max(parseInt(100 - e.target.value,10), 0), 100) / 100})}
                      step='1'
                      min={0}
                      max={100}
                    />
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md='8' lg='4'>
                <MoneyInput
                  name='costPerCompletion'
                  value={costPerCompletion}
                  onChange={(val) => this.setState({costPerCompletion:val})}
                />
              </Col>
              <Col md='2' lg='4'>
                <MoneyDisplay>
                  {roundUpToNearestTensOfCent(costPerCompletion * revenueSplit)}
                </MoneyDisplay>
              </Col>
              <Col md='2' lg='4'>
                <MoneyDisplay>
                  {costPerCompletion - roundUpToNearestTensOfCent(costPerCompletion * revenueSplit)}
                </MoneyDisplay>
              </Col>
            </Row>
          </div>
        )}
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
        {showSuperadminFeatures && (
          <Label check>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Input
              type='checkbox'
              checked={isUsingCostPerCompletionPricing}
              onClick={(e) => this.setState({isUsingCostPerCompletionPricing:e.target.checked})}
            />
            &nbsp;Use cost per completion pricing
          </Label>
        )}
      </Form>
    )
  }
}

CampaignBudgetForm.defaultProps = {
  isShowingTutorial:true
};

export default CampaignBudgetForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignBudgetForm.js